import { createFileRoute } from '@tanstack/react-router'

import { AutopayAccountsScreen } from './-components/autopay-accounts-screen.tsx'

export const Route = createFileRoute('/cs-tools/autopay-accounts')({
  component: AutopayAccountsScreen
})
